import React from 'react';
import { PARAMS } from '../../../../config';
const redStyle = { background: 'red' };

const Row = row => {
    const td = PARAMS.map(([ param ]) => {
        const value = row[param];
        const style = param == 'roi' && value < 0 ? redStyle : {};


        return <td key={param} style={style}>{value}</td>
    });

    return (
        <tr>
            {td}
        </tr>
    );
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/AdKernel/components/Table/components/Row/index.js